import { z } from "zod";

export const UpdatePermissionSchema = z.object({
    name: z.string().nonempty(),
    group: z.string().nonempty(),
});

export type UpdatePermissionForm = z.infer<typeof UpdatePermissionSchema>;